import React from "react";
import _ from "lodash";
import Select from "react-select";
import SwitchTabs from "components/common/SwitchTabs";
import RevenueDistributionDrilldownPieChart from "./RevenueDistributionDrilldownPieChart";

const DISTRIBUTION_TYPE = {
  GARD: "GOOGLE_AD_REVENUE_DISTRIBTUTION",
  NIRDL: "NET_INCREASED_REVENUE_DISTRIBUTION",
};

class RevenueDistributionSection extends React.Component {
  constructor(props) {
    super(props);

    const options = [
      {
        value: DISTRIBUTION_TYPE.GARD,
        label: "Ad Revenue Distribution",
      },
      {
        value: DISTRIBUTION_TYPE.NIRDL,
        label: "Net Increased Revenue Distribution",
      },
    ];
    const selectedValue = options[0];

    this.state = {
      options,
      selectedValue,

      isRequestTypeDimension: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDimensionChange = this.handleDimensionChange.bind(this);
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });
  }

  handleDimensionChange(value) {
    this.setState({
      isRequestTypeDimension: value,
    });
  }

  render() {
    const { options, selectedValue, isRequestTypeDimension } = this.state;
    const {
      distributionData,
      selectedPubId,
      selectedNetworkId,
      selectedYieldSetIds,
      selectedRequestType,
      startDate,
      endDate,
      selectedCurrency,
    } = this.props;

    const parsedMetricKey =
      selectedValue.value === DISTRIBUTION_TYPE.GARD
        ? "googleAdRevenue"
        : "netIncreasedRevenue";

    const dimensionOptions = [
      {
        value: true,
        label: "Request Type",
      },
      {
        value: false,
        label: `${selectedNetworkId === -1 ? "Networks" : "Yield Sets"}`,
      },
    ];

    return (
      <div className="p-4">
        {/* <div className="font-semibold text-lg text-gray-800 mb-4 text-center">
          Revenue Distribution
        </div> */}

        {!_.isNil(selectedRequestType) && (
          <div className="mb-2">
            <SwitchTabs
              tabs={dimensionOptions}
              selectedTabKey={isRequestTypeDimension}
              handleChange={this.handleDimensionChange}
            ></SwitchTabs>
          </div>
        )}

        <Select
          // className="w-24"
          defaultValue={selectedValue}
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isSearchable={false}
        />

        <div>
          <RevenueDistributionDrilldownPieChart
            reports={distributionData}
            metricKey={parsedMetricKey}
            isRequestTypeDimension={
              !_.isNil(selectedRequestType) && isRequestTypeDimension
            }
            selectedPubId={selectedPubId}
            selectedNetworkId={selectedNetworkId}
            selectedYieldSetIds={selectedYieldSetIds}
            selectedCurrency={selectedCurrency}
            selectedRequestType={selectedRequestType}
            startDate={startDate}
            endDate={endDate}
          ></RevenueDistributionDrilldownPieChart>
        </div>
      </div>
    );
  }
}

export default RevenueDistributionSection;
